import './social-buttons.scss'
import {FacebookShareButton, TwitterShareButton} from "react-share";
export default function SocialButtons() {
    return (
        <div className="social-buttons">
            <FacebookShareButton url={"https://www.dargett.com/"}
                quote={"First Armenian Craft Beer"}
                hashtag={"#dargett"}
                description={"aiueo"}
                className="round primary-outline">
                    <img src="/static/icons/facebook-dark.svg" alt=""/>
                    Facebook
            </FacebookShareButton>
            <br/>
            <TwitterShareButton title={"test"}
                url={"https://www.dargett.com/"}
                hashtags={
                    ["#dargett"]
                }className="round primary-outline">
                
                    <img src="/static/icons/twitter-dark.svg" alt=""/>
                    Tweet
            </TwitterShareButton>
        </div>
    )
}
